module.exports = {
    extends: [
        '/',
        'templates',
        'core',
        'table',
        'table',
    ],

    config: {
        buttonContext: 'projectTerms',
        showHead: true,
        showIDs: true,
        // showTDVerticalTop: true,
        isSortable: true,
        preventSortOfField: {
            statusFlagsSummary: true,
        },
        rowActionsInline: true,
        rowActionsProperties: {
            colWidth: '105px',
        },
        rowActions: {
            edit: true,
            customs: [
                // {
                //     buttonType: 'showLocation',
                // },
                {
                    buttonType: 'delete',
                    neutral: true,
                }
            ]
        },
        heartbeatRefreshOn: {
            'reconnect': true,
            'resourceChanged.bo_status': true,
            'resourceChanged.bo_projectTerms': true,
        },
    },

    model: {
        projectMeta: {}, // @see MARK: CUSTOMER_PROJECT_META_LOADER
        resourceFilters: {
            order: [{
                fieldCode: 'timeRange',
                direction: 'asc'
            },{
                fieldCode: 'projectTermID',
                direction: 'asc'
            }]
        }
    },

    methods: {
        onPrepareDone(){
            this.config.customHeadActionsFormMapping = {
                buttons: [
                    { buttonType: 'showInsert', context: this.config.buttonContext, positive: true }
                ]
            }
        },

        onSubmitDone(callerComponent, entityID, entityData, insertPerformed){
            switch(((callerComponent || {}).config || {}).entityContext){
                case 'projectTerms':
                    const myProjectID = ((this.model.parentEntityForTable || {}).baseFilters || {}).projectID
                    const foundProjectID = ((entityData || {}).attributes || {}).projectID

                    if(myProjectID && foundProjectID && myProjectID == foundProjectID){
                        if(insertPerformed && entityID && entityData){
                            this.showEdit(entityID, entityData)
                        }
                    }
                    break;
            }
        },

        onHeartbeat(message, heartbeatPrewarmedResourceHashes){
            const refreshers = this.config.heartbeatRefreshOn || {}
            const key = message.heartbeatKey

            if(refreshers[key] && (
                (
                    key !== 'resourceChanged.bo_projectTerms' &&
                    key !== 'resourceChanged.bo_status'
                ) ||
                (key === 'resourceChanged.bo_projectTerms' && (
                    message.data.projectID == ((this.model.parentEntityForTable || {}).baseFilters || {}).projectID ||
                    (message.data.projectIDs || {})[((this.model.parentEntityForTable || {}).baseFilters || {}).projectID]
                )) ||
                (key === 'resourceChanged.bo_status' && this.isAtLeastOneStatusIDLoaded(message.data.statusIDs))
            )){
                this.refreshData(true, { refreshResourcesViaHeartbeatKey: key, heartbeatPrewarmedResourceHashes })
            }
        },

        // which properties is a customer allowed to change?
        onProjectMetaChanged(meta, nextMeta){
            if(
                this.config.isReady
                &&
                (!meta.hash || meta.hash !== nextMeta.hash)
            ){
                this.refresh(false)
            }
        },

        // which properties is a customer allowed to change?
        onBeforeRender(){
            if(!this.config.customHeadActionsFormMappingBackup){
                this.config.customHeadActionsFormMappingBackup = {
                    ...(this.config.customHeadActionsFormMapping || {})
                }
            }
            if(!this.config.rowActionsBackup){
                this.config.rowActionsBackup = {
                    ...(this.config.rowActions || {})
                }
            }

            const grantedChanges = ((this.model.projectMeta || {}).grantedChanges || {}).project || {}

            // const status = this.model.projectMeta.status
            if(grantedChanges.major){
                this.config.customHeadActionsFormMapping = {
                    ...(this.config.customHeadActionsFormMappingBackup || {})
                }
                this.config.rowActions = {
                    ...(this.config.rowActionsBackup || {})
                }
            } else {
                this.config.customHeadActionsFormMapping = {}
                this.config.rowActions.customs = []
            }
        },
    },

    hooks: {
        // which properties is a customer allowed to change?
        projectMetaChanged($element, options){
            const meta = { ...(this.model.projectMeta || {}) }
            const nextMeta = this.model.projectMeta = (options || {}).projectMeta || {}
            this.onProjectMetaChanged(meta, nextMeta)
        },
    },
}